import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import { FC } from "react";

export interface DeleteConfirmationModalProps {
	onClose: () => void;
	onConfirm: () => void;
}

export const DeleteConfirmationModal: FC<DeleteConfirmationModalProps> = ({
	onClose,
	onConfirm,
}) => {
	return (
		<Dialog
			open
			onClose={onClose}>
			<DialogTitle>Permanently delete this dataset?</DialogTitle>
			<DialogContent>
				<Typography variant="body2">
					Once deleted, this dataset will no longer be accesible.
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={onClose}
					color="inherit">
					Cancel
				</Button>
				<Button
					variant="contained"
					color="error"
					onClick={onConfirm}>
					Permanently delete
				</Button>
			</DialogActions>
		</Dialog>
	);
};
